import React from 'react';

/** The asterisk that follows the label of a required field. */
const KoobRequiredMark = () => (
  <span className="ml-1 text-red-500" aria-hidden="true">
    *
  </span>
);

export default KoobRequiredMark;
